import { post, useFetch } from 'utils/sdk.ts';
import { useTranslation } from 'react-i18next';

export type DeclineFTPOfferDto = {
  value: string;
  label: string;
};

export type DeclineFTPOffersDto = DeclineFTPOfferDto[];

export const requestFlightTicketProposalExtension = ({
  flightTicketProposalUUID,
  extensionNote,
}: {
  flightTicketProposalUUID: string;
  extensionNote?: string | null;
}) =>
  post<{ message: string }>(
    `api/customer-facing/flight-ticket-proposals/${flightTicketProposalUUID}/request-extension`,
    {
      extension_note: extensionNote ?? null,
    }
  );

export const useDeclineReasons = () => {
  const { i18n } = useTranslation();
  return useFetch<DeclineFTPOfferDto[]>(
    `api/customer-facing/flight-ticket-proposals/decline-reasons?language=${i18n.language}`
  );
};

export const declineFlightTicketProposalOffer = ({
  flightTicketProposalUUID,
  declineReason,
  declineNote,
}: {
  flightTicketProposalUUID: string;
  declineReason: string;
  declineNote: string | null;
}) =>
  post(`api/customer-facing/flight-ticket-proposals/${flightTicketProposalUUID}/decline`, {
    decline_reason: declineReason,
    decline_note: declineNote,
  });
